import Cookies from 'js-cookie';
import _ from 'lodash';

export const getElectronicSignatureProperties = async ({
  isMultipleSignature,
  isReadyToCreatePkcs7,
  getPkcs7 = () => {},
  documentToSignName,
  shouldPkcs7BeGenerated = true,
  electronicSignaturesList = [],
  singleElectronicSignature = null,
}) => {
  let pkcs7 = '';

  if (!isReadyToCreatePkcs7) {
    return;
  }

  if (shouldPkcs7BeGenerated) {
    try {
      pkcs7 = await getPkcs7();
      if (!Boolean(pkcs7)) {
        return;
      }
    } catch (error) {
      throw error;
    }
  }

  const { names_03: userName, paternal_surname_03: userPaternalSurname } = Cookies.get();
  const userFullName = `${userName} ${userPaternalSurname}`;

  // Extraer nombres de los firmantes
  let signersNames = [];
  if (isMultipleSignature && electronicSignaturesList.length > 0) {
    signersNames = electronicSignaturesList
      .map((signature) => _.get(signature, 'signatureInfo.CommonName', '').toUpperCase())
      .filter((name) => name !== '');
  } else if (!isMultipleSignature && singleElectronicSignature) {
    const signerName = _.get(
      singleElectronicSignature,
      'signatureInfo.CommonName',
      ''
    ).toUpperCase();
    if (signerName !== '') {
      signersNames = [signerName];
    }
  }

  const electronicSignatureProperties = {
    Pkcs7Original: pkcs7,
    CertificateType: 3,
    FileName: documentToSignName,
    UserName: userFullName,
    isMultipleSignature,
    signersNames,
  };

  return electronicSignatureProperties;
};
